import { render, staticRenderFns } from "./ProfileImageWithPopCard.vue?vue&type=template&id=6d22fda6&scoped=true&"
import script from "./ProfileImageWithPopCard.vue?vue&type=script&lang=js&"
export * from "./ProfileImageWithPopCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d22fda6",
  null
  
)

export default component.exports